import { Form } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { Template, TemplateProps } from './Template';
import { PostInsightFormValues } from './types';

export type PostInsightFormProps = FormAction<PostInsightFormValues> & Omit<TemplateProps, 'onSubmit'>;

export const PostInsightForm = ({ onSubmit, defaultValues, ...templateProps }: PostInsightFormProps) => (
  <Form.Provider values={defaultValues} onSubmit={onSubmit}>
    <Template {...templateProps} />
  </Form.Provider>
);

export * from './types';
